import React from 'react';
import {
  Text,
  Button,
  Combobox,
  Option,
  Menu,
  MenuTrigger,
  MenuPopover,
  MenuList,
  MenuItem,
  tokens,
} from '@fluentui/react-components';
import { Add24Regular, Edit24Regular, Delete24Regular, MoreHorizontal24Regular } from '@fluentui/react-icons';
import { KanbanBoard, BoardInfo } from '../../types/kanban';

interface BoardSelectorProps {
  board: KanbanBoard | null;
  boardList: BoardInfo[];
  isReadOnly: boolean;
  onSwitchBoard: (boardId: string) => void;
  onCreateBoard: () => void;
  onRenameBoard: () => void;
  onDeleteBoard: () => void;
}

export const BoardSelector: React.FC<BoardSelectorProps> = ({
  board,
  boardList,
  isReadOnly,
  onSwitchBoard,
  onCreateBoard,
  onRenameBoard,
  onDeleteBoard,
}) => {
  if (isReadOnly) return null;

  return (
    <div style={{
      display: 'flex',
      gap: '0.75rem',
      alignItems: 'center',
      backgroundColor: tokens.colorNeutralBackground1,
      padding: '0.5rem 1rem',
      borderBottom: `1px solid ${tokens.colorNeutralStroke2}`
    }}>
      <Text weight="semibold" size={400}>Board:</Text>
      <Combobox
        placeholder="Select a board"
        value={board?.title || ''}
        selectedOptions={board ? [board.id] : []}
        onOptionSelect={(_, data) => {
          if (data.optionValue && data.optionValue !== board?.id) {
            onSwitchBoard(data.optionValue);
          }
        }}
        style={{ minWidth: '100px', maxWidth: '400px', flex: 1 }}
      >
        {boardList.map(b => (
          <Option key={b.id} value={b.id} text={b.title}>
            {b.title}
          </Option>
        ))}
      </Combobox>

      <Menu>
        <MenuTrigger disableButtonEnhancement>
          <Button icon={<MoreHorizontal24Regular />} appearance="subtle" size="small" />
        </MenuTrigger>
        <MenuPopover>
          <MenuList>
            <MenuItem icon={<Add24Regular />} onClick={onCreateBoard}>
              New Board
            </MenuItem>
            <MenuItem icon={<Edit24Regular />} onClick={onRenameBoard}>
              Rename Board
            </MenuItem>
            <MenuItem
              icon={<Delete24Regular />}
              onClick={onDeleteBoard}
              disabled={boardList.length <= 1}
            >
              Delete Board
            </MenuItem>
          </MenuList>
        </MenuPopover>
      </Menu>
    </div>
  );
};
